import { Pipe, PipeTransform } from 'angular-ts-decorators';

export type OrderByListFilter<T> = (
  value: T[],
  list: any[],
  key?: string,
  reverse?: boolean,
) => T[];

export interface IOrderByList<T> {
  transform: OrderByListFilter<T>;
}

import {
  reverse,
  indexOf,
  intersection,
  without,
  concat,
  sortBy,
} from 'lodash';

/**
 * Orders a list starting with elements that appears on the other list
 * @param {any[]} value flat values or objects
 * @param {any[]} list of values with order we want on the value array
 * @param {string} key if provided value is treated as {[key]: any}[]
 * @param {boolean} reverseFlag if true the list is reversed before applying
 * @return {any} order list
 */
@Pipe({ name: 'orderByList' })
export class OrderByListPipe implements PipeTransform, IOrderByList<any> {
  constructor() {
    'ngInject';
  }

  public transform(
    value: any[],
    list: any[],
    key?: string,
    reverseFlag?: boolean,
  ): any[] {
    if (!angular.isArray(list)) {
      return value;
    }

    if (!angular.isDefined(key)) {
      const commonPart = intersection(value, list);

      if (reverseFlag) {
        reverse(commonPart);
      }

      return concat(commonPart, without(value, ...list));
    }

    const sortHelper = (element) => {
      const index = indexOf(list, element[key]);

      if (index === -1) {
        return Infinity;
      }

      if (reverseFlag) {
        return -index;
      }

      return index;
    };

    return sortBy(value, sortHelper);
  }
}
